import {
  AppBar,
  Box,
  Button,
  IconButton,
  SwipeableDrawer,
  Toolbar,
  Typography,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import { useState, useEffect } from "react";
import { ReactComponent as IconNotificaciones } from "icons/ic_menu_notificaciones.svg";
import { ReactComponent as IconMenu } from "icons/ic_menu.svg";
import logo_inicio from "../assets/img/logo_inicio.png";
import CalendarBar from "./CalendarBar/CalendarBar";
import { Link, useLocation } from "react-router-dom";
import { getHomeLabel, getCalendarioLiturgicoLabel, getSantoralLabel, getAniversariosLabel, getMaximasLabel, getMultimediaLabel, getConstitucionesLabel, getDirectorioLabel, getAcuerdosLabel, getCelebracionesLabel } from 'hooks/useLabels';
import axios from 'axios';
import { ProjectConfig } from 'Global';

export default function DrawerMenu(props: any) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [sortedMenuItems, setSortedMenuItems] = useState<any[]>([]);

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setDrawerOpen(open);
    };

  // const pathname = window.location.pathname;
  const today: any = new Date();
  const todayFormated = [
    today.getFullYear(),
    String(today.getMonth() + 1).padStart(2, "0"),
    String(today.getDate()).padStart(2, "0"),
  ].join("-");
  // localStorage.setItem('fecha_view', todayFormated);
  const [fechaView, setFechaView] = useState(todayFormated);

  const signOut = () => {
    localStorage.removeItem("ltkn");
    //remove cookies
    document.cookie = "ltkn=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    window.location.href = "/";
  };

  const { pathname } = useLocation();

  const handleRedireccionar = () => {
    console.log("click", pathname);
    pathname !== "/" && props.setLoading(true);
  };

  // Load menu items from API
  useEffect(() => {
    axios.get(ProjectConfig.api_url, {
      params: {
        request: 'home_icons_app'
      }
    })
    .then((response) => {
      if (response.data.success && response.data.icons) {
        // Sort icons by orden field
        const sorted = [...response.data.icons].sort((a, b) => a.orden - b.orden);
        setSortedMenuItems(sorted);
      }
    })
    .catch((err) => {
      console.log('Error loading menu items:', err);
    });
  }, []);

  // Route mapping for each module
  const moduleRoutes: Record<string, string> = {
    'santoral': '/santoral',
    'liturgia_horas': '/liturgia-horas',
    'misas': '/misas',
    'fiestas': '/fiestas',
    'ano_liturgico': '/ano-liturgico',
    'oraciones': '/oraciones',
    'rituales': '/ritos',
    'celebraciones': '/celebraciones',
    'aniversarios': '/aniversarios',
    'maximas': '/maximas',
    'multimedia': '/multimedia',
    'constituciones': '/constituciones',
    'directorio': '/Directorio',
    'acuerdos_capitulares': '/acuerdos-capitulares',
  };

  // Label mapping for each module
  const moduleLabelKeys: Record<string, string> = {
    'santoral': 'santoral',
    'liturgia_horas': 'liturgia_horas',
    'misas': 'misa_del_dia',
    'fiestas': 'propios',
    'ano_liturgico': 'ano_liturgico',
    'oraciones': 'oraciones',
    'rituales': 'ritos',
    'celebraciones': 'celebraciones',
    'aniversarios': 'aniversarios',
    'maximas': 'maximas',
    'multimedia': 'multimedia',
    'constituciones': 'constituciones',
    'directorio': 'directorio',
    'acuerdos_capitulares': 'acuerdos_capitulares',
  };

  return (
    <div>
      <AppBar
        position="static"
        sx={{ top: "auto", bottom: 0, backgroundColor: "var(--fondo1)" }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {/* inicio / */}
          {/* 
        <Link to="/">
            <img id='logo_inicio' src={logo_inicio} alt="logo" />
        </Link> */}

          <Link
            to="/"
            onClick={() => {
              localStorage.setItem("date", todayFormated);
              window.location.href = "/";
            }}
          >
            <IconButton color="inherit">
              <img id="logo_inicio" src={logo_inicio} alt="logo" />
            </IconButton>
          </Link>

          <Link
            to="/notificaciones"
            onClick={() => {
              pathname !== "/notificaciones" && props.setLoading(true);
            }}
          >
            <IconButton color="inherit">
              <IconNotificaciones />
            </IconButton>
          </Link>
          <Link
            to="/cuenta"
            onClick={() => {
              pathname !== "/cuenta" && props.setLoading(true);
            }}
          >
            <IconButton color="inherit">
              <SettingsIcon sx={{ fill: "var(--color1)" }} />
            </IconButton>
          </Link>
          <IconButton color="inherit" onClick={toggleDrawer(true)}>
            <IconMenu />
          </IconButton>
        </Toolbar>
      </AppBar>

      <SwipeableDrawer
        id="drawerMenu"
        anchor="bottom"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        disableBackdropTransition={true}
        disableDiscovery={true}
        disableSwipeToOpen={true}
        //max height 80%
        sx={{
          height: "90%",
          "& .MuiDrawer-paper": {
            height: "90%",
            boxSizing: "border-box",
          },
        }}
      >
      

        <div className="listMenu" id="menu_newo">
          {sortedMenuItems.map((item) => {
            const moduleKey = item.module_key;
            const route = moduleRoutes[moduleKey] || '/';
            const labelKey = moduleLabelKeys[moduleKey] || moduleKey;

            return (
              <Link
                key={moduleKey}
                to={route}
                onClick={() => {
                  setDrawerOpen(false);
                  if (route === '/santoral') {
                    props.setLoading(false);
                  } else if (pathname !== route) {
                    props.setLoading(true);
                  }
                }}
              >
                <Button>{getHomeLabel(labelKey)}</Button>
              </Link>
            );
          })}

          <Link
            to="/cuenta"
            onClick={() => {
              setDrawerOpen(false);
              pathname !== "/cuenta" && props.setLoading(true);
            }}
          >
            <Button>{getHomeLabel('cuenta')}</Button>
          </Link>

          <Button onClick={signOut}>{getHomeLabel('cerrar_sesion')}</Button>
        </div>
      </SwipeableDrawer>
    </div>
  );
}
